import { render, staticRenderFns } from "./CompanyXzcfListBlock.vue?vue&type=template&id=0594fba0&scoped=true"
import script from "./CompanyXzcfListBlock.vue?vue&type=script&lang=js"
export * from "./CompanyXzcfListBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0594fba0",
  null
  
)

export default component.exports